export const formatAddressFromJawgs = (feature) => {
    return {
        label: feature.properties.label,
        name: feature.properties.name,
        postcode: feature.properties.postalcode,
        state: feature.properties.macroregion,
        city: feature.properties.locality,
        country: feature.properties.country,
        countryCode: feature.properties.country_code,
        latlng: {
            lng: feature.geometry.coordinates[0],
            lat: feature.geometry.coordinates[1],
        },
    };
};

export const formatAddressForJawgForApi = (feature) => {
    return {
        label: feature.properties.label,
        address_line_1: feature.properties.name,
        postal_code: feature.properties.postalcode,
        city: feature.properties.locality,
        country_code: feature.properties.country_code,
        geocode: {
            lng: feature.geometry.coordinates[0],
            lat: feature.geometry.coordinates[1],
        },
    };
};
